function LegalSection({ title, children }) {
    return (
        <section className="legal__section">
            <h2>{title}</h2>
            {children}
        </section>
    );
}

export default LegalSection;
